angular.module('bzProjectPreferencesModule', [])
